export const MAIN_TAB = {
  complianceDashboard: "complianceDashboard",
  staffTracking: "staffTracking",
};

export const COMPLIANCE_SUB_TAB = {
  currentPolicies: 1,
  archivedPolicies: 2,
  complianceAnalytics: 3,
};

export const STAFF_SUB_TAB = {
  currentPolicies: 1,
  archivedPolicies: 2,
};

export const sortingVariablesForCurrentPolicies = {
  Category : 1,
  Title : 2,
  StartDate : 3,
  DueDate : 4,
  LastUpdatedOn : 5
};
